// extracted by mini-css-extract-plugin
module.exports = {"container":"Grid_container___PRvb","spaced":"Grid_spaced__6t2os","item":"Grid_item__oU6Qb","sized":"Grid_sized__rQXD7"};